import {action, computed, observable, toJS} from "mobx";
import {instance, mesAutobind} from "@posco/posco-shared";
import O10g014112Repository from "../repository/O10g014112Repository";

@mesAutobind
class O10g014112Stores {

  @instance(O10g014112Repository.instance)
  static instance;

  repository;

  constructor(repository) {
    this.repository = repository;
  }



  @action
  change(data) {
    return O10g014112Repository.instance.change(data)
      .then(result => result);
  }

  @action
  profile(formData) {
    return O10g014112Repository.instance.profile(formData)
      .then(result => result);
  }

  @action
  profile2(path) {
    return O10g014112Repository.instance.profile2(path)
      .then(result => result);
  }

}

export default O10g014112Stores;
